import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import {useParams, useNavigate, useResolvedPath} from 'react-router';
import Button from './atoms/Buttons';

const TabPanelContainer = styled.div`
  display: ${props => props.$isActive ? 'block' : 'none'};
  width:100%;
`;

const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 32px;
  gap:24px;
`;

const TabHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
`;

const TabContent = styled.div`
  display: flex;
  flex-direction:row;
  margin-bottom: 16px;
`;

const Tab = ({children, isActive, onClick, title}) => {
  return (
    <Button
      role="tab"
      aria-selected={isActive}
      tabIndex={isActive ? 0 : -1}
      variant={isActive ? "solid" : "outline"}
      onClick={onClick}
      style={{flex: "1"}}
    >
      {title}
    </Button>
  );
};

const TabPanel = ({ isActive, children }) => {
  return (
    <TabPanelContainer $isActive={isActive}>
      {children}
    </TabPanelContainer>
  );
};

const Tabs = ({children, onChange}) => {
  
  const {activeTab: routeTab} = useParams();

  const navigate = useNavigate();
  // La parte de la URL que coincidió con la ruta (lo que era match.url en react-router 5).
  const {pathname: matchedUrl} = useResolvedPath('.');
  const baseUrl = routeTab ? matchedUrl.replace(new RegExp(`/${routeTab}$`), '') : matchedUrl;

  // La pestaña de la URL manda cuando coincide con un tabId; si no, queda la última elegida con un click.
  const routeIndex = routeTab ? React.Children.toArray(children).findIndex(child => child.props.tabId === routeTab) : -1;
  const [activeTab, setActiveTab] = useState(routeIndex >= 0 ? routeIndex : 0);
  const [syncedRouteIndex, setSyncedRouteIndex] = useState(routeIndex);
  if (routeIndex !== syncedRouteIndex) {
    setSyncedRouteIndex(routeIndex);
    if (routeIndex >= 0) setActiveTab(routeIndex);
  }

  const handleTabClick = (index) => {
    setActiveTab(index);
    const tabsArray = React.Children.toArray(children);
    const tabId = tabsArray[index]?.props.tabId;
    if (tabId) {
      navigate(`${baseUrl}/${tabId}`);
    }
    if (onChange && tabId) {
      onChange(tabId);
    }
  };

  useEffect(() => {
    if (routeIndex >= 0 && onChange) {
      onChange(routeIndex);
    }
  }, [routeIndex, onChange]);

  return (
    <TabContainer role="tablist">
      <TabHeader>
        {React.Children.map(children, (child, index) => {
          return React.cloneElement(child, {
            isActive: index === activeTab,
            onClick: () => handleTabClick(index),
          });
        })}
      </TabHeader>
      <TabContent>
        {React.Children.map(children, (child, index) => {
          return index === activeTab && (
            <TabPanel key={index} isActive>
              {child.props.children}
            </TabPanel>
          );
        })}
      </TabContent>
    </TabContainer>
  );
};

export {Tabs, Tab};
